
import React, { useState } from 'react';

import { ILuxuryHome } from '@share/common-types';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
  descriptionRef: React.RefObject<HTMLElement>;
}

const DisplayMoreButton = ({ showMore, display, setShowMore }: { display: boolean, showMore?: boolean, setShowMore?: (showMore: boolean) => void }) => {
  if (!display || !setShowMore) {
    return null;
  }

  return (
    <button className="read-more" onClick={() => setShowMore(!showMore)}>
      Read {showMore ? 'less' : 'more'}
    </button>
  );
}

const DescriptionSection = ({ title, list, showMore, setShowMore }: { title: string, list: any[], showMore: boolean, setShowMore?: (showMore: boolean) => void }) => {
  if (!list?.length) {
    return null;
  }

  return (
    <>
      <h2 style={{ marginTop: 0 }}>{title}</h2>

      {list?.slice(0, showMore ? list?.length : 3).map((d: string, i: number) => <p key={`${d}-${i}`}>{d}</p>)}

      <DisplayMoreButton showMore={showMore} setShowMore={setShowMore} display={list?.length > 3} />
    </>
  );
}

export const LuxuryHomesDetailsDescription: React.FC<IProps> = ({ home, descriptionRef }) => {
  const [showMoreProperty, setShowMoreProperty] = useState(false);
  const [showMoreNeighborhood, setShowMoreNeighborhood] = useState(false);

  const surroundings = home?.surroundings?.map((s: any) => s.items).flat().map(i => `${i.name} ${i.proximity && `- ${i.proximity}`} ${i.distanceInMiles && `- ${i.distanceInMiles} miles`}`);

  return (  
    <section id="description" className="property-section no-border-section" ref={descriptionRef}>
      <DescriptionSection title="Property Description" list={home?.descriptions} showMore={showMoreProperty} setShowMore={setShowMoreProperty} />

      <DescriptionSection title="Destination Description" list={[home?.description]} showMore />

      <DescriptionSection title="Neighborhood Description" list={surroundings} showMore={showMoreNeighborhood} setShowMore={setShowMoreNeighborhood} />
    </section>
  );
};
